import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Events, LoadingController, AlertController } from 'ionic-angular';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { GlobalVars } from '../providers/global-vars';
import { TranslateService } from 'ng2-translate/ng2-translate'; 

/*
  Generated class for the ApiCaller provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/

const SERVER_URL = 'https://app.gategoing.com/api/api.php';

@Injectable()
export class ApiCaller {
  public data: any;

  constructor(public http: Http, public events: Events,public loadingCtrl: LoadingController,
              public alertCtrl: AlertController, private translate: TranslateService, public globalVars : GlobalVars) {
    console.log('Hello ApiCaller Provider');
    
  
  }
  load(request: any, message: any, showError: any) {
  //    console.log("Calling API: "+JSON.stringify(request));
      let loader = null;
      if (message){
          loader = this.loadingCtrl.create({
              content: message
          });
          loader.present();
      }
     /*
      if (this.data) {
        // already loaded data
        return Promise.resolve(this.data);
      }
*/
      // don't have the data yet
      return new Promise(resolve => {
        // We're using Angular HTTP provider to request the data,
        // then on the response, it'll map the JSON data to a parsed JS object.
        // Next, we process the data and resolve the promise with the new data.
          request.request.appVersion = this.globalVars.appVersion;
          console.log("apiCaller request is: "+JSON.stringify(request));
        this.http.post(SERVER_URL,request)
            .timeout(15000)
          .map(res => res.json())
          .subscribe(data => {
            if (message)
                loader.dismiss();
            console.log("apiCaller  return is: "+JSON.stringify(data));
            if (data.result != 200 && ((message&&showError) || showError)){
                console.log("Error return is: "+JSON.stringify(data));
                this.translate.get(data.error, null).subscribe(localizedValue =>{
                    data.error = localizedValue;
                    let alert = this.alertCtrl.create({
                      title: this.globalVars.msgError,
                      subTitle: data.error,
                      buttons: [this.globalVars.msgOK]
                    });
                    alert.present();
                });
            }
            // we've got back the raw data, now generate the core schedule data
            // and save the data for later reference
            this.data = data;
           // console.log("ApiCaller: data is: "+JSON.stringify(data));
            
            resolve(this.data);
          }, error => {
            if (message){
                loader.dismiss();
            }
            if (showError){
                let alert = this.alertCtrl.create({
                  title: this.globalVars.msgOops,
                  subTitle: this.globalVars.msgUnableToReach,
                  buttons: [this.globalVars.msgOK]
                });
                alert.present();
            }
            console.log("error : "+error+" while sending request :"+JSON.stringify(request));
            
            resolve(null);
        });
      });
   }

}



// WEBPACK FOOTER //
// ./src/providers/api-caller.ts